import { intersection, isEmpty, map } from 'lodash'

import { ROLES } from '../../common/constants'

const checkIfQcAssignableUser = user =>
  !isEmpty(
    intersection(map(user?.roles, 'name'), [
      ROLES.ADMIN.value,
      ROLES.GUILD_LEAD.value,
      ROLES.TRAINER.value,
      ROLES.ML_DETECTIVE.value,
      ROLES.QC.value,
      ROLES.QC_TRAINEE.value,
    ]),
  )

export default checkIfQcAssignableUser
